export default {
    namespaced: true,
    state: {
        logo: ''
    },
    getters: {
        logo: state => state.logo
    },
    mutations: {},
    actions: {}
};
